import TableContainer from "components/tables/TableContainer"
import React, { useMemo } from "react"

const TableFilter = ({ content }) => {
  const columns = useMemo(
    () => [
      {
        Header: "日付",
        accessor: "date",
      },
      {
        Header: "入金方法",
        accessor: "payment_method",
      },
      {
        Header: "金額",
        accessor: "amount_of_money",
      },
    ],
    []
  )

  const listDataTable = useMemo(() => {
    if (!content) return []
    return content.map((v, i) => ({
      date: v.date,
      payment_method: v.payment_method,
      amount_of_money: v.amount_of_money,
    }))
  }, [content])

  return (
    <>
      <TableContainer
        columns={columns}
        data={listDataTable}
        pagination={false}
      />
    </>
  )
}

export default TableFilter
